export class CookieHelper {

    constructor() {
        this.cookieKey = "cookieAgreementSpire";
        this.cookieKeySurvey = 'closeEnquiery';
        this.init();
    }

    bannerCookies() {
        var that = this;
        var cookieKeyBase = 'collapseBanner';

        $(".topAdvert-banner").each(function () {

            var bannerId = $(this).data("bannerid");
            var cookieKey = cookieKeyBase + bannerId;
            var cookie = that.readCookie(cookieKey);
            var $bannerContent = $(this).find('.js-accordion--reverse__content');
            var $bannerToggle = $(this).find('.js-accordion--reverse__toggle');
            var $bannerCTA = $(this).find('.button');
            var bannerMaximised = false;

            if (!cookie) {

                $bannerContent.addClass('is-on');
                $bannerToggle.addClass('is-on');
                bannerMaximised = true;

                //gaHelper.trackEvent("Banner-" + bannerId, "Banner Displayed Maximised", undefined, undefined, true);


            } else {

                $bannerContent.removeClass('is-on');
                $bannerToggle.removeClass('is-on');
                $('.js-accordion--reverse__content--minimised').removeClass('is-on');

                bannerMaximised = false;

                //gaHelper.trackEvent("Banner-" + bannerId, "Banner Displayed Minimised", undefined, undefined, true);
            }

            $bannerToggle.on("click", function (e) {
                if (bannerMaximised) {
                    if (cookie === null) {
                        that.writeCookie(cookieKey, true, 1);
                    }
                    //gaHelper.trackEvent("Banner-" + bannerId, "User Minimised Banner");
                } else {
                    //gaHelper.trackEvent("Banner-" + bannerId, "User Maximised Banner");
                }
            });

            $bannerCTA.on("click", function (e) {
                if ($bannerToggle.hasClass("is-on")) {
                    //gaHelper.trackEvent("Banner-" + bannerId, "User Clicked CTA - Banner Maximised");
                } else {
                    //gaHelper.trackEvent("Banner-" + bannerId, "User Clicked CTA - Banner Minimised");
                }
            });
        });
    }

    surveyCookies() {

        var that = this;
        var desktopSurveyMaxCount = $("#desktopSurveyMaxCount").val();
        var mobileSurveyMaxCount = $("#mobileSurveyMaxCount").val();

        // if survey is disabled forget it
        if (desktopSurveyMaxCount == -1 && mobileSurveyMaxCount == -1) return;
        var $surveyModal = $(".js-modal--survey");
        var cookie = that.readCookie(that.cookieKeySurvey);

        // if the cookie is not there
        if (cookie === null) {

            // decide on max value dependant on desktop/mobile
            var surveyMaxCount = -1;
            var isDesktop = true;

            if ($(".site-header").is(':visible')) {
                isDesktop = true;
                surveyMaxCount = desktopSurveyMaxCount;
            }
            else {
                isDesktop = false;
                surveyMaxCount = mobileSurveyMaxCount;
            }

            // get the counter i.e. should we show the survey ?
            $.ajax({
                url: apilocation + 'SurveyApi/ShowSurvey',
                method: "GET",
                dataType: "xml",
                data: {
                    "surveyMaxCount": surveyMaxCount,
                    "isDesktop": isDesktop
                }
            }).done(function (data) {

                if (data === true) {

                    // write the cookie so this person does not see again for 30 days
                    that.writeCookie(that.cookieKeySurvey, "1", 30);

                    // incrment the relevant counter
                    $.ajax({
                        url: apilocation + 'SurveyApi/' + (isDesktop ? "IncrementDesktopSurveyCount" : "IncrementMobileSurveyCount"),
                        method: "POST",
                    });

                    // show the survey in a while
                    setTimeout(function () {
                        $surveyModal.addClass("is-on");
                    }, 15000);

                }

            });

        }

        $surveyModal.on("click", ".js-enquiry-form-modal__close", function (e) {
            $(this).parents(".js-modal").removeClass("is-on");
        });
        $surveyModal.on("click", ".js-enquiry-form__give-feedback", function (e) {

            //get the page url the user have been to before click the "Give feedback" button
            var firstPage = window.location.href;;
            localStorage.setItem("firstPage", firstPage);
            var storedfirstPage = localStorage.getItem('firstPage');


            $(this).parents(".js-modal").removeClass("is-on");
            //var myWindow = window.open("", "_blank", "toolbar=no,scrollbars=yes,resizable=yes,top=0,left=0,width='700',height=700" );
            var modalUrl = location.protocol + '//' + location.host + '/please-wait.html'
            var myWindow = window.open(modalUrl, "myWindow", "scrollbars=1,menubar=1,resizable=1,width=660,height=700");   // Opens a new window
            ;
        });


    }

    writeCookie(name, value, days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
        var cookieString = name + "=" + value + expires + "; path=/";
        document.cookie = cookieString;
        return this;
    }

    readCookie(name) {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1, cookie.length);
            }
            if (cookie.indexOf(name + "=") == 0) {
                return cookie.substring(name.length + 1, cookie.length);
            }
        }
        return null;
    }

    init() {

        var that = this;

        if (!that.readCookie(that.cookieKey)) {
            $('.js-cookie-bar').addClass('show');
        }
        else {
            $('.js-cookie-bar').removeClass('show');
        }

        $('.js-cookie-bar-agree').on("click", function (e) {
            e.preventDefault();
            that.writeCookie(that.cookieKey, "1", 30);
            $('.js-cookie-bar').removeClass("show");
        });

        //that.surveyCookies();
    }
}

